/*
 *   File : service.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : global function for API calls using axios
 *   Integrations : axios, jwt-encode, jwt-decode
 *   Version : v1.1
 */

import axios from 'axios';
import CONSTANTS from "./config";

const service = async function (isGet, api, params, token, byPass = false, rawBlob = false) {

    try {
        const API_URL = CONSTANTS.apiBaseUrl + api;
        let headers = {
            'Content-Type': 'text/plain',
        };

        if (token) {
            headers['Access-Token'] = token;
        }

        if (isGet) {
            // GET request
            return await axios.get(API_URL, {
                headers: headers,
                timeout: 120000,  // Timeout after 2 minutes
            })
                .then(async (response) => {
                    const parsed_data = response.data;

                    return parsed_data
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            sessionStorage.clear();
                            window.location.href = "/"
                        }
                        return error.response.data;
                    } else if (error.request) {
                        return { message: 'Network connection time out', status_code: 504 }
                    }
                });
        } else {

            return await axios.post(API_URL, params, {
                headers: headers,
                timeout: 120000,
                responseType: rawBlob ? 'blob' : 'json',
            })
                .then(async (response) => {
                    if (rawBlob) return response; // ⬅️ Don't decode Blob
                    const parsed_data = response.data;
                    return parsed_data;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            sessionStorage.clear();
                            window.location.href = "/"
                        }
                        return error.response.data;
                    } else if (error.request) {
                        return { message: 'Network connection time out', status_code: 504 }
                    }
                });
        }
    } catch (err) {
        console.error(api, 'API error ::', err);
        return {
            status: false,
            message: "We are facing a server outage error now. Please try later or contact our support team.",
            status_code: 400
        };
    }
};



export default service;
